<ops-application-navigator [appId]="appId" [navigationConfig]="navigationLinks" (clickEvent)="redirect($event)"></ops-application-navigator>
